import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
const COVERS = ['https://cdn.magicpatterns.com/uploads/d1YfztQqvwHq4RwiWFL5Gr/secret-love-book-cover-draft-3.png', 'https://cdn.magicpatterns.com/uploads/7Dm9hsP953Akdfn3RmdhNy/secret-love-book-cover-draft-4.png'];
const GeometricPattern = () => <svg viewBox="0 0 100 100" className="w-full h-full opacity-20" data-id="element-104">
    <rect x="0" y="0" width="50" height="50" fill="currentColor" data-id="element-105" />
    <circle cx="75" cy="25" r="25" fill="currentColor" data-id="element-106" />
    <path d="M 50 50 L 100 50 L 50 100 Z" fill="currentColor" data-id="element-107" />
  </svg>;
const BookMockup = ({
  src,
  title
}: {
  src: string;
  title: string;
}) => <motion.div initial={{
  rotateY: -15,
  perspective: 1000
}} whileHover={{
  rotateY: -5,
  transition: {
    duration: 0.5
  }
}} className="relative group cursor-pointer" style={{
  transformStyle: 'preserve-3d'
}} data-id="element-108">
    {/* Book Spine Shadow */}
    <div className="absolute -left-[20px] top-0 bottom-0 w-[20px] bg-black/20 origin-right" style={{
    transform: 'rotateY(-90deg)'
  }} data-id="element-109" />

    {/* Main Cover */}
    <div className="relative rounded-r-lg overflow-hidden shadow-[20px_20px_60px_rgba(0,0,0,0.3)] border-l border-white/10" data-id="element-110">
      <img src={src} alt={title} className="w-full h-auto block" data-id="element-111" />
      {/* Glossy overlay */}
      <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/5 to-white/20 pointer-events-none" data-id="element-112" />
    </div>

    {/* Pages edge effect */}
    <div className="absolute right-0 top-0 bottom-0 w-[4px] bg-gray-200 rounded-r-lg shadow-inner" data-id="element-113" />
  </motion.div>;
export function IdeasPage() {
  return <div className="min-h-screen bg-[#d9e2e8] p-2 md:p-4 font-sans selection:bg-accent selection:text-white" data-id="element-114">
      <div className="main-container max-w-[2000px] mx-auto bg-card rounded-[1.5rem] md:rounded-[2rem] border-2 border-[#ef3e23] shadow-sm min-h-[calc(100vh-2rem)] flex flex-col" data-id="element-115">
        <Navigation activePath="/" data-id="element-116" />
        <main className="flex-1 px-4 md:px-16 py-4 md:py-6 space-y-8 md:space-y-16" data-id="element-117">
          {/* Hero Section - Compacted */}
          <section className="relative flex flex-col justify-center pt-2 md:pt-4 pb-4 md:pb-8" data-id="element-118">
            <div className="max-w-6xl" data-id="element-119">
              <h1 className="text-[clamp(2rem,8vw,6rem)] font-semibold leading-[0.95] md:leading-[0.9] tracking-[-0.04em] text-ink" data-id="element-120">
                Secret Love <br className="hidden sm:block" data-id="element-121" />
                or Honour?
                <span className="text-accent inline-block w-[0.15em] h-[0.15em] rounded-full ml-[0.05em] mb-[0.1em]" data-id="element-122" />
              </h1>
              <div className="mt-4 max-w-sm text-sm md:text-base leading-[1.5] text-ink font-medium" data-id="element-123">
                Exploring the visual narrative for N Minhas' latest work.
                Western heart meets Eastern tradition.
              </div>
            </div>
          </section>

          {/* Book Covers Section */}
          <section className="space-y-8 pb-12" data-id="element-124">
            <div className="bg-white rounded-[1rem] p-4 md:p-8 border border-[#2b2b2b]/5 flex flex-col justify-between relative overflow-hidden shadow-sm" data-id="element-125">
              <div className="space-y-2 relative z-10" data-id="element-126">
                <span className="bg-[#ef3e23] text-white px-3 py-1 text-[10px] font-bold uppercase tracking-widest rounded-full w-fit" data-id="element-127">
                  Initial Concepts
                </span>
                <h2 className="font-display text-xl md:text-4xl tracking-[-0.02em] leading-tight" data-id="element-128">
                  Physical Book Concepts
                </h2>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-[1800px] mx-auto pt-8 -mx-4 md:-mx-8 px-4 md:px-8" data-id="element-129">
              {COVERS.map((src, i) => <div key={i} className="space-y-6" data-id="element-130">
                  <div className="flex items-center gap-3" data-id="element-131">
                    <div className="w-2 h-2 rounded-full bg-accent" data-id="element-132" />
                    <span className="text-xs font-bold uppercase tracking-widest text-ink/40" data-id="element-133">
                      Option 0{i + 1}
                    </span>
                  </div>
                  <div className="px-0" data-id="element-134">
                    <BookMockup src={src} title={`Book Cover Concept ${i + 1}`} data-id="element-135" />
                  </div>
                </div>)}
            </div>
          </section>
        </main>
      </div>
    </div>;
}